<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <h3 class="text-center" style="margin-top: 0">Programas cursados</h3>
    <p class="text-center text-primary">
      <small>Se lista todos los cursos y programas inscritos del estudiante seleccionado.</small>
    </p>

    <v-progress-linear v-if="loading" indeterminate color="blue darken-2" height="2" class="mt-2" />

    <div class="row" v-show="false">
      <div class="col-sm-2">Gestion:</div>
      <div class="col-sm-4">
        <Gestiones :model="gestion" :default="actual" />
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-striped table-condensed table-hover">
        <thead>
          <tr>
            <th>Nro</th>
            <th style="min-width: 50px"><small>Code</small></th>
            <th>Programa</th>
            <th>Sede</th>
            <th>Version</th>
            <th>Grupo</th>
            <th>Gestion</th>
            <th>Modalidad</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          <tr :key="ind" v-for="(p, ind) in programas">
            <td>{{ ind + 1 }}</td>
            <td>
              <small> {{ formatCode(p) }}</small>
            </td>
            <td>{{ parsePrograma(p.postgrado) }}</td>
            <td>{{ p.sede.nombre }}</td>
            <td>{{ p.version }}</td>
            <td>{{ p.grupo }}</td>
            <td>{{ p.gestion }}</td>
            <td>{{ parseModalidad(p.modalidad) }}</td>
            <td>
              <v-progress-linear v-if="p.loading" indeterminate color="indigo"></v-progress-linear>
              <button class="btn btn-sm btn-default" title="Ver Inscripciones" @click="verInscripciones(p)">
                <span class="glyphicon glyphicon-list-alt"></span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="text-center">
      <div style="display: inline-block" v-show="loading" class="loader"></div>
    </div>
    <Alertas ref="xalertar" />
    <notifications group="auth" position="bottom right" />
  </div>
</template>

<script>
  import Gestiones from '@/components/AGestiones.vue';
  import { parseJsonError } from '@/components/Utils.js';
  import Alertas from '@/components/AAlertas.vue';
  import gql from 'graphql-tag';

  export default {
    data() {
      return {
        actual: { gestion: 2025 },
        idestudiante: -1,
        programas: [],
        gestion: { gestion: null },
        loading: false, 
      };
    },
    watch: {
      'gestion.gestion': function(a) {
        if (a == null) return;
        this.actual.gestion = a.gestion;
        this.getDatos();
      },
    },
    components: { Gestiones, Alertas },
    methods: {
      formatCode(p) {
        return `${p.postgrado.categoria.nombre.slice(0, 1)}-${p.id}`.toUpperCase();
      },
      parsePrograma(pos) {
        if (pos == null) return '';
        return pos.categoria.nombre + ' - ' + pos.nombre;
      },
      parseModalidad(s) {
        if (s == 'S') return 'Semi presencial';
        else if (s == 'P') return 'Presencial';
        else return 'Virtual';
      },
      verInscripciones(programa) {
        const id = this.$store.state.CARGO.id;
      window.console.log('id',id);
      if(id == -11 || id == 12 || id == 13 ){
        this.$root.$notify.show(`No tiene permitido ver esta informacion`, { color: 'red', x: 'right' });
        return;
      }
        programa.loading = true;
        var sql = gql`query{ getPrograma(id:${programa.id}){ programa_modulos{ id, idmodulo,iddocente,idprograma,course_id, inicio, fin, programa{id,nombre_compuesto,plataforma_id} modulo{id, sigla,nombre}, docente{id,email,num_doc,nombres,pri_apellido,seg_apellido,usuario_moodle,clave_moodle,telefono1}, estado},id,plataforma_id, course_category_id,fase,modalidad,version,grupo,arte,fecha_inicio,fecha_fin,gestion,mod_finalizado,sucursal_id,estado,inscripciones{id,estado_ins},sede{id,nombre,unidad_negocio},universidad{id,nombre},codigo,nombre_compuesto,postgrado{id,nombre,area{id,nombre},categoria{id,nombre}}} }`;
        this.$apollo
          .query({ query: sql, variables: { cursor: this.cursor } })
          .then(({ data }) => {
            let datos = data.getPrograma;
            this.$store.dispatch('programa/addPrograma', datos);
            this.$store.dispatch('programa/selectPrograma', datos);
            this.$router.push({ name: 'programains' });
            programa.loading = false;
          })
          .catch(() => {
            programa.loading = false;
          });
      },
      getDatos() {
        this.loading = true;
        var sql = gql`
      query{
        getProgramasByPersona(student_id:${this.idestudiante}){
          id
          postgrado{id,nombre,categoria{nombre}}
          sede{nombre}
          version,grupo,gestion,modalidad,fecha_registro
        }
      }
      `;

        this.$apollo
          .query({
            query: sql,
          })
          .then((data) => {
            //window.console.log('personas res:', data);
            if (!data.data.getProgramasByPersona) data.data.getProgramasByPersona = [];
            data.data.getProgramasByPersona.map((x) => {
              x.loading = false;
            });
            this.programas = data.data.getProgramasByPersona;
            this.$refs.xalertar.reset();
            this.loading = false;
          })
          .catch((error) => {
            this.msg = error;
            window.console.error(error);
            this.$notify(parseJsonError(error, 'getPrograma'));
            this.loading = false;
          });
      },
    },
    mounted() {
      this.idestudiante = JSON.parse(sessionStorage.xestudiante).id;
      this.actual.gestion = new Date().getFullYear();
      this.getDatos();
      
    },
  };
</script>
